import Dialog from "../../atoms/dialog";
import { Button, Typography, Box } from "@material-ui/core";
import { useState, useEffect, Fragment } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import DeleteField from "../fields/DeleteField";
import DeleteProfile from "../profiles/DeleteProfile";


const DeleteProfileAlert = (props) => {
    const { onCompletion, onClose, id } = props;

    const [open, setOpen] = useState(false)


    const handleClose = () => {
        setOpen(false);
        onClose();
    }

    return (

        <Dialog
            // title={"Delete"}
            open={true}
            handleClose={handleClose}
        >

            <DeleteProfile onCompletion={onCompletion} id={id} onClose={onClose} />

        </Dialog >
    )

}

export default DeleteProfileAlert;